export const FREQUENT_PROJECTS = {
  MAX_COUNT: 20,
  LIST_COUNT_DESKTOP: 5,
  LIST_COUNT_MOBILE: 3,
  ELIGIBLE_FREQUENCY: 3,
};

export const HOUR_IN_MS = 3600000;

export const STORAGE_KEY = 'frequent-projects';



// WEBPACK FOOTER //
// ./projects_dropdown/constants.js